import React from 'react';

export default function TrashConversationIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1 3.66667H11M4.75 6.33333V10.3333M7.25 6.33333V10.3333M1.625 3.66667L2.25 11.6667C2.25 12.0203 2.3817 12.3594 2.61612 12.6095C2.85054 12.8595 3.16848 13 3.5 13H8.5C8.83152 13 9.14946 12.8595 9.38388 12.6095C9.6183 12.3594 9.75 12.0203 9.75 11.6667L10.375 3.66667M4.125 3.66667V1.66667C4.125 1.48986 4.19085 1.32029 4.30806 1.19526C4.42527 1.07024 4.58424 1 4.75 1H7.25C7.41576 1 7.57473 1.07024 7.69194 1.19526C7.80915 1.32029 7.875 1.48986 7.875 1.66667V3.66667"
        stroke="#333333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
